import axios from 'axios';
import {useMutation} from 'react-query';
import { toast } from 'react-toastify';

const useGetPdfModulesReport = (projectId) => {
  const { mutateAsync, isLoading } = useMutation(async ({ projectId }) => {
    const config = {responseType: 'blob',};
    return await axios.get(`/standardization/${projectId}/report/modules`, config);
  });

  const getModulesReport = async (projectId, options) => {
    mutateAsync(
        { projectId },
        {
          onSuccess: (res) => {
            toast.success("Successfully created modules pdf");
            const file = new Blob([res.data], {
              type: "application/pdf",
            });

            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          },
        }
    );
  };

  return {
    getModulesReport,
    isLoading,
  };
};

export default useGetPdfModulesReport;
